import * as React from 'react'
import Ui from 'ui'
import TextField from 'ui/molecules/TextField'

function BuilderChoiceExtraProp({ placeholder, type, id, value, onChange }) {
  switch (type) {
    case 'text':
      return (
        <TextField
          onChange={(v) => onChange(id, v)}
          placeholder={placeholder}
          value={value}
        />
      )
    case 'integer':
      return (
        <Ui.NumericText
          integerOnly
          minValue={0}
          onChange={(v) => onChange(id, v)}
          placeholder={placeholder}
          value={value}
        />
      )

    case 'number':
      return (
        <Ui.NumericText
          onChange={(v) => onChange(id, v)}
          placeholder={placeholder}
          value={value}
        />
      )
    default:
      return null
  }
}

export default BuilderChoiceExtraProp
